export default __webpack_public_path__ + "static/media/secondimgd.5551fbec.png";